export function getGlobalGa() {
  if (window.ga) {
    return window.ga
  }
  let pollCount = 0
  const maxPollCount = 10
  const intervalMs = 50
  return new Promise((resolve, reject) => {
    const intervalId = setInterval(() => {
      pollCount++
      if (window.ga) {
        clearInterval(intervalId)
        resolve(window.ga)
      } else if (pollCount === maxPollCount) {
        return reject(new Error('window.ga took too long to appear'))
      }
    }, intervalMs)
  })
}



// WEBPACK FOOTER //
// ./src/lib/getGlobalGa.js